import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {RelatedCost} from "../models/basic/related-cost";
import {AxiosResponse} from "axios";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";

export type RelatedCostFilter = Filters & {
	years?: string,
	client_id?: string,
	client?: string,
	project?: string,
	ordering?: string,
};

export class RelatedCostService extends AbstractService<RelatedCost> {
	
	constructor() {
		super(URLS.REPORT_RELATED_COST);
	}
	
	override processFilters = (filters?: Filters) : Filters | undefined => {
		const processedFilter = {
			...filters
		};
		
		if (processedFilter?.client_id === "0") {
			delete processedFilter.client_id;
		}
		
		if(processedFilter.years) {
			if(!processedFilter.years) {
				delete processedFilter.years;
			}
		}
		
		return processedFilter;
	}
	
	async listYears(): Promise<AxiosResponse<{ years: number[] }>> {
		const path = `${this.path}list_years/`;
		return await trackPromise(Api.get(path));
	}

	async createAmortization(instance: RelatedCost, filters?: Filters, expands?: Expands): Promise<AxiosResponse<RelatedCost>> {
		const allParams = this.processParameters(filters, expands);
		return await trackPromise(Api.post<RelatedCost>(`${this.path}amortization/`, instance, {params: allParams}));
	}
	
}
